import React, { useState } from "react";
import Drawer from "../../../../../../components/Drawer";
import ReactStrapTable from "../../../../../../components/reactStrapTable";

const FaxDetails = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState([]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const formatter = (row) => {
    return (
      <span className="fax-link" onClick={toggle}>
        {/* {name} */} test
      </span>
    );
  };

  function arrowSign() {
    return (
      <div>
        {" "}
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-arrow-up-right"
          style={{ color: "#df1313" }}
        >
          <line x1={7} y1={17} x2={17} y2={7} />
          <polyline points="7 7 17 7 17 17" />
        </svg>
      </div>
    );
  }

  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
      headerStyle: { width: 100 },
      cellRenderer: ({ rowData: row }) => arrowSign(row),
    },
    {
      dataField: "name",
      text: "Date",
      sort: true,
      headerStyle: { width: 100 },
    },
    {
      dataField: "price",
      text: "Fax Status",
      headerStyle: { width: 100 },
    },
    {
      dataField: "doctorName",
      text: "Doctor Name",
      headerStyle: { width: 100 },
    },
    {
      dataField: "faxLink",
      text: "Fax Link",
      headerStyle: { width: 100 },
      cellRenderer: ({ rowData: row }) => formatter(row),
    },
  ];
  return (
    <div>
      <div className="table-card scroll-table position-relative border-0 pt-2">
        <ReactStrapTable
          id="fax-details"
          fixedColumn
          height={50 * data.length}
          columns={columns}
          data={data}
        />
      </div>
      <Drawer
        direction="end"
        isOpen={isOpen}
        toggle={toggle}
        title="Fax Details"
      >
        <iframe
          title="1"
          src="https://www.africau.edu/images/default/sample.pdf"
          frameBorder="0"
          scrolling="auto"
          height="100%"
          width="100%"
        />
      </Drawer>
    </div>
  );
};

export default FaxDetails;
